export const ExternalUrls = {
	IMEWarehouse: 'https://www.ime.co.ir/warehouse.html'
};
